export default class DtoUserStatistic {
    constructor(obj) {
        this.id = obj.id
        this.login = obj.login
        this.statisticDate = obj.statisticDate
        this.module = obj.module
        this.value = obj.value
    }
}